import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import imgSave from "../saveImg";
import Auth from "../Auth";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [{
                note: "",
                other: ""
            }],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }


    getDateData = (date) => {
        let data = this.state.data;
        fetch(`/_10_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {

            this.setState({ loading: false, data: x.data || [] });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_10', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (data[0] && !data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table10', 1.5, '10.00', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1" id="table10">

                    <Row style={{ margin: "20px 0", }} className="title" >
                        <Row >
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        loading: true,
                                        data: []
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Row style={{ margin: "10px 0", marginTop: 20 }}>10.0 CSR and Community Activities 企业社会责任及社区活动</Row>
                        {!this.state.loading || this.state.print ? <TextArea
                            rows={4}
                            placeholder="请输入备注！"
                            value={this.state.data[0] ? this.state.data[0].note : ""}
                            onChange={(e) => {
                                let data = this.state.data;
                                data[0] = { ...data[0], note: e.target.value || "" };
                                this.setState({
                                    data
                                });
                            }}
                        /> : null}
                    </Row>
                    <Row style={{ margin: "20px 0", }} className="title">
                        <Row style={{ margin: "10px 0" }}>11.0 Other Issues 其他事宜</Row>
                        {!this.state.loading || this.state.print ? <TextArea
                            rows={4}
                            placeholder="请输入备注！"
                            value={this.state.data[0] ? this.state.data[0].other : ""}
                            onChange={(e) => {
                                let data = this.state.data;
                                data[0] = { ...data[0], other: e.target.value || "" };
                                this.setState({
                                    data
                                });
                            }}
                        /> : null}
                    </Row>

                </div>
                <Auth loading={this.state.loading} auth="edit_10">
                    <Row className="table-footer-btn" style={{ textAlign: "right", paddingRight: 24 }}>
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Row>
                </Auth>

            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/10/index.js